const data = {
  id: 1,
  title: 'Read and tick T or F.',
  subTitle: 'Đọc và chọn đúng hoặc sai.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/c35145b5-6be2-4691-8bca-e43b2c808fb8.mp3',
  imageUrl: '',
  questionText: '',
  question: '',
  answers: [
    { answer: 'Nam is ten years old.', isCorrect: true },
    { answer: "There are five people in Nam's family.", isCorrect: false },
    { answer: 'His flat is far from the city center.', isCorrect: false },
  ],

};

export default data;
